import React from 'react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { DetailContent as LegacyDetailContent } from 'routes/Menu/components/Detail/DetailContent'

type LegacyDetailContentProps = React.ComponentProps<typeof LegacyDetailContent>

type DetailContentProps = Omit<LegacyDetailContentProps, 'recipe'> & {
  recipe: MenuRecipe | RecipeQueryResponse | null
}

export const DetailContent = (props: DetailContentProps) => {
  // eslint-disable-next-line react/jsx-props-no-spreading, react/destructuring-assignment
  return <LegacyDetailContent {...props} recipe={props.recipe as MenuRecipe | null} />
}
